import React from 'react'
import { Box } from '@mui/material'
import images from 'assets/images'
import HighlightChip from 'components/HighlightChip'
import SignUpMavenForm from 'components/pages/signup/SignUpMavenForm'
import SignupTemplate from 'components/templates/SignupTemplate'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import AdvantagesContainer, { Advantage } from 'components/ui/AdvantagesContainer'
import FullScreenLoading from 'components/ui/FullScreenLoading'

const advantages: Advantage[] = [
  {
    image: images.signUpSeller.PLUGIN,
    alt: 'Painless listing',
    title: '<strong>Painless</strong> listing',
    text: 'Create your company or freelancer profile in minutes. Brag about your expertise and track record.',
  },
  {
    image: images.signUpSeller.PROMOTION,
    alt: 'Amplify your brand',
    title: 'Amplify <strong>your brand</strong>',
    text: 'NachoNacho reaches hundreds of thousands of businesses through various ecosystems. Become discoverable by those businesses.',
  },
  {
    image: images.signUpSeller.ACQUISITION_CHANNEL,
    alt: 'Ideal matchmaking',
    title: 'Ideal <strong>matchmaking</strong>',
    text: 'NachoNacho has direct relationships with software buyers and first party data on their software stack. Your expertise will be offered to them in the right place at the right time.',
  },
]

const SignUpMaven: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  if (loading) return <FullScreenLoading />

  return (
    <SignupTemplate
      left={
        <>
          <img src={images.LOGO_SYMBOL_BLUE_BACKGROUND} alt="logo" style={{ width: '110px', height: '110px' }} />

          <Box height="30px" />

          <Box>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">The World's Largest</h2>
            <h2 className="text-blue fs-32 fw-700 m-0">Software & Professional Services</h2>
            <h2 className="text-dark-blue fs-32 fw-700 m-0">Marketplace</h2>
          </Box>

          <Box my="16px">
            <HighlightChip fontSize="14px">
              Reach <strong>new and relevant</strong> customers
            </HighlightChip>
          </Box>

          <Box maxWidth="393px">
            <p className="m-0 fs-14">
              List your services in the NachoNacho Marketplace and get discovered by businesses specifically looking for your
              expertise.
            </p>
          </Box>

          <Box height="54px" />

          <AdvantagesContainer advantages={advantages} />
        </>
      }
      right={<SignUpMavenForm />}
    />
  )
}

export default SignUpMaven
